import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';
import styled, { inputImages, inputNumbers, inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { Zones } from '../TitleList';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { insertZoneEntry } from '../../Store/PHPSlice/zone';

const ZoneEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        zoneNm: '',
        dt: '',
        userId: userdata?.ID
    });

    const dispatch = useDispatch();


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.zoneNm === '') {
            alert('Please Enter Zone Name');
            return;
        }

        dispatch(insertZoneEntry(formData))
            .unwrap()
            .then((result) => {
                console.log('POST request successful!', result);
                alert("Zone Added");
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error while making POST request:', error);
            });
    };

    const isDesktop = useMediaQuery('(min-width:768px)');


    const fieldsecond = [
        // { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Zone Name', name: 'zoneNm' }
    ];

    return (
        <>
            <Titlebar data={Zones} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Zone Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>

                                {fieldsecond?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}




                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ZoneEntry;
